import React, { useState } from 'react';
import axios from 'axios';
import { AJAX_URL } from '../../config/index.js';

function CutCard({ cut }) {
  const { permalink, image, image_alt, name, lean, id, is_favorite } = cut;
  const [favorite, setFavorite] = useState(!!is_favorite);
  const [pending, setPending] = useState(false);

  const toggleFavorite = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (pending) return;
    setPending(true);

    const payload = new FormData();
    payload.append('id', id);

    axios
      .post(`${AJAX_URL}post_wl_handle_favorites`, payload)
      .then(({ data }) => {
        if (data.success) {
          setFavorite(data.data.action === 'added');
        } else if (data.data && data.data.message === 'No User Found') {
          window.location.href = '/login';
        }
        setPending(false);
      })
      .catch(() => setPending(false));
  };

  return (
    <a
      href={permalink}
      className="cut-card card grid__col-xs-12 grid__col-sm-6 grid__col-lg-3"
    >
      <div className="cut-card__media-box">
        <button
          type="button"
          className="cut-card__heart"
          data-user-favorite={favorite ? 'true' : 'false'}
          aria-label={favorite ? 'Remove from favorites' : 'Save to favorites'}
          onClick={toggleFavorite}
        >
          <i className={favorite ? 'saved' : 'save'}></i>
        </button>
        {lean && <span className="cut-card__badge">Lean</span>}
        <img
          src={image ? image : ''}
          className="card__media"
          alt={image_alt ? image_alt : ''}
        />
      </div>
      <h4 className="card__title u--text-align-center">{name}</h4>
    </a>
  );
}

export default function CutsList({ cutsList }) {
  return (
    <div id="cuts__list" className="cuts__list">
      <section className="section">
        <div className="container">
          <div className="grid grid--card">
            {cutsList.map((cut) => (
              <CutCard key={cut.id} cut={cut} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
